import type { Erfassung } from '../api/typen'
import { beschreibe, fachName, istZugeordnet } from './beschreibung'

/**
 * P10-03: Verifizierungsreport mit Bildern, nach Versorgungspunkt geordnet. Sonderfaelle stehen
 * unter ihrem Versorgungspunkt neben den Schraenken - dieselbe Ablagestruktur wie im Standardfall
 * (P7-04). Ohne sie waere der Report fuer die Pruefung vor der Bestellung unvollstaendig.
 */
export default function ReportInhalt({ erfassung }: { erfassung: Erfassung }) {
  return (
    <>
      {erfassung.versorgungspunkte.map((punkt) => (
        <section key={punkt.id} className="gruppe" style={{ gap: 16 }}>
          <h2 className="s">
            {punkt.bezeichnung} <span className="sek">{punkt.vpCode}</span>
          </h2>

          {punkt.schraenke.map((schrank) => (
            <section key={schrank.id} className="gruppe">
              <div className="kopfzeile">
                <h3 className="s">{schrank.bezeichnung}</h3>
                <span className="sek">{schrank.schrankCode}</span>
              </div>

              {schrank.faecher.map((fach) => {
                const ergebnis = fach.nutzerErgebnis ?? fach.kiVorschlag
                return (
                  <div key={fach.id} className="karte">
                    <div className="zeile">
                      <b>{fachName(fach)}</b>
                      <span className={fach.nutzerErgebnis ? 'st st-ok' : 'st st-warn'}>
                        {fach.nutzerErgebnis ? 'bestätigt' : 'nur Vorschlag'}
                      </span>
                    </div>

                    <div className="paar">
                      {fach.bildObenVorhanden && (
                        <figure>
                          <img src={`/api/faecher/${fach.id}/bild/oben`} alt="Draufsicht" />
                          <figcaption>Draufsicht</figcaption>
                        </figure>
                      )}
                      {fach.bildVorneVorhanden && (
                        <figure>
                          <img src={`/api/faecher/${fach.id}/bild/vorne`} alt="Frontalsicht" />
                          <figcaption>Frontalsicht</figcaption>
                        </figure>
                      )}
                    </div>

                    <span className="sek">{ergebnis ? beschreibe(ergebnis) : 'noch kein Ergebnis'}</span>
                  </div>
                )
              })}
            </section>
          ))}

          {punkt.sonderfaelle.map((sonderfall) => (
            <section key={`sf-${sonderfall.id}`} className="gruppe">
              <div className="kopfzeile">
                <h3 className="s">Sonderfall: {sonderfall.bezeichnung}</h3>
                <span className="sek">{sonderfall.sonderfallCode}</span>
              </div>
              {sonderfall.beschreibungFreitext && <p className="notiz">{sonderfall.beschreibungFreitext}</p>}

              <div className="karte">
                <b>Gesamtfoto</b>
                {sonderfall.gesamtfotoVorhanden ? (
                  <img src={`/api/sonderfaelle/${sonderfall.id}/gesamtfoto`} alt="Gesamtfoto" />
                ) : (
                  <span className="st st-warn">fehlt</span>
                )}
              </div>

              {sonderfall.ebenen.map((ebene) => (
                <div key={ebene.ebeneNr} className="karte">
                  <div className="zeile">
                    <b>Ebene {ebene.ebeneNr}</b>
                    <span className={istZugeordnet(ebene) ? 'st st-ok' : 'st st-warn'}>
                      {istZugeordnet(ebene) ? 'zugeordnet' : 'nicht zugeordnet'}
                    </span>
                  </div>
                  {ebene.fotoVorhanden && (
                    <img
                      src={`/api/sonderfaelle/${sonderfall.id}/ebenen/${ebene.ebeneNr}/foto`}
                      alt={`Ebene ${ebene.ebeneNr}`}
                    />
                  )}
                  <span className="sek">
                    {istZugeordnet(ebene) ? beschreibe(ebene) : 'noch nicht zugeordnet'}
                  </span>
                </div>
              ))}
            </section>
          ))}
        </section>
      ))}
    </>
  )
}
